import moment from 'moment'

// App-wide display formats (e.g. "10 Sep 2026" / "10 Sep 2026 2:30 PM").
export const DATE_FORMAT = 'DD MMM YYYY'
export const DATE_TIME_FORMAT = 'DD MMM YYYY h:mm A'

// The zone's short name in the viewer's language, e.g. "(AEST)" or "(EDT)".
// Browsers only know abbreviations for zones familiar to that language, so
// elsewhere this falls back to an offset such as "(GMT+10)".
export const timeZoneLabel = (date: Date, locale?: string): string => {
  const name = new Intl.DateTimeFormat(locale, { timeZoneName: 'short' })
    .formatToParts(date)
    .find(part => part.type === 'timeZoneName')?.value
  return name ? `(${name})` : ''
}

// Backend timestamps are UTC; one without an offset is read as UTC too, then
// shown in the viewer's local time.
const toLocal = (iso: string): moment.Moment => moment.utc(iso).local()

export const formatDate = (iso: string): string =>
  toLocal(iso).format(DATE_FORMAT)

export const formatLocalDateTime = (iso: string): string => {
  const local = toLocal(iso)
  return `${local.format(DATE_TIME_FORMAT)} ${timeZoneLabel(
    local.toDate()
  )}`.trim()
}

export const formatUtcDateTime = (iso: string): string =>
  moment.utc(iso).format(DATE_TIME_FORMAT)
